export function parseTimestampMs(
  value: Date | string | number | null | undefined,
): number | null {
  if (value === null || value === undefined) {
    return null;
  }

  if (value instanceof Date) {
    const dateValue = value.getTime();
    return Number.isFinite(dateValue) ? dateValue : null;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  const numericValue = Number(trimmedValue);
  if (Number.isFinite(numericValue)) {
    return numericValue;
  }

  const parsedDate = Date.parse(trimmedValue);
  return Number.isNaN(parsedDate) ? null : parsedDate;
}
